import script from "./_codeEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./_codeEditor.vue?vue&type=script&setup=true&lang=js"

import "./_codeEditor.vue?vue&type=style&index=0&id=73fc4241&lang=scss&scoped=true"

import exportComponent from "D:\\PHPStudio\\xampp_old2\\htdocs\\office_studio\\2026\\agustus\\frontend-olsera-open-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73fc4241"]])

export default __exports__